import React from "react";
import { CardHeader } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import GroupIcon from "@material-ui/icons/Group";
import PersonIcon from "@material-ui/icons/Person";

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
  },
  cardHeaderRoot: {
    flex: 1,
    minWidth: 0,
    padding: "16px 8px",
  },
  titleText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const InternalChatInfo = ({ chat, user }) => {
  const classes = useStyles();

  const getDisplayName = () => {
    if (!chat) return "";
    if (chat.isGroup && chat.name) return chat.name;
    if (chat.users && chat.users.length > 0) {
      const other = chat.users.find((u) => u.id !== user?.id) || chat.users[0];
      return other.name;
    }
    return "";
  };

  const getSubheader = () => {
    if (!chat) return "";
    if (chat.isGroup && chat.users && chat.users.length > 0) {
      const names = chat.users
        .filter((u) => u.id !== user?.id)
        .map((u) => u.name)
        .join(", ");
      return names || "";
    }
    return "";
  };

  const getAvatar = () => {
    if (!chat) return null;
    if (chat.isGroup) {
      return (
        <Avatar style={{ backgroundColor: "#075E54" }}>
          <GroupIcon />
        </Avatar>
      );
    }
    if (chat.users && chat.users.length > 0) {
      const other = chat.users.find((u) => u.id !== user?.id) || chat.users[0];
      return (
        <Avatar style={{ backgroundColor: "#075E54" }}>
          {other.name ? other.name.charAt(0).toUpperCase() : <PersonIcon />}
        </Avatar>
      );
    }
    return (
      <Avatar style={{ backgroundColor: "#075E54" }}>
        <PersonIcon />
      </Avatar>
    );
  };

  return (
    <div className={classes.headerContainer}>
      <CardHeader
        classes={{ root: classes.cardHeaderRoot }}
        titleTypographyProps={{
          className: classes.titleText,
          variant: "subtitle1",
        }}
        subheaderTypographyProps={{
          className: classes.titleText,
          variant: "body2",
        }}
        avatar={getAvatar()}
        title={getDisplayName()}
        subheader={getSubheader()}
      />
    </div>
  );
};

export default InternalChatInfo;
